export class Enum<T> {
  constructor(public readonly value: T) {}
  public toString(): string {
    return this.value.toString();
  }
}
